import TraceTile from './TraceTile';
import TraceTileWithFallback from './TraceTileWithFallback';

export { TraceTile, TraceTileWithFallback };
export default TraceTile;
